var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlayHebrew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 54,
    fill: "none",
    viewBox: "0 0 180 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-play-hebrew_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M173.333 54H6.667C3 54 0 50.962 0 47.25V6.75C0 3.038 3 0 6.667 0h166.666C177 0 180 3.038 180 6.75v40.5c0 3.712-3 6.75-6.667 6.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M142.581 40.5h2.488V23.624h-2.488V40.5Zm22.41-10.797-2.852 7.317h-.086l-2.96-7.317h-2.68l4.438 10.227-2.53 5.688h2.596l6.84-15.915h-2.766Zm-14.109 8.88c-.816 0-1.953-.412-1.953-1.433 0-1.303 1.416-1.802 2.638-1.802 1.094 0 1.608.239 2.273.565-.194 1.563-1.523 2.67-2.959 2.67h.001Zm.299-9.25c-1.801 0-3.666.804-4.438 2.584l2.208.934c.472-.934 1.351-1.238 2.273-1.238 1.287 0 2.594.783 2.616 2.172v.173c-.451-.26-1.415-.65-2.595-.65-2.38 0-4.804 1.323-4.804 3.799 0 2.258 1.953 3.713 4.139 3.713 1.673 0 2.594-.76 3.175-1.65h.085v1.303h2.402v-6.471c0-2.996-2.208-4.668-5.061-4.668Zm-15.376 2.424h-3.538v-5.785h3.538c1.86 0 2.916 1.559 2.916 2.892 0 1.308-1.056 2.892-2.916 2.892Zm-.064-8.134h-5.961V40.5h2.487v-6.394h3.474c2.758 0 5.469-2.021 5.469-5.24 0-3.22-2.711-5.242-5.469-5.242Zm-32.508 14.963c-1.718 0-3.157-1.457-3.157-3.458 0-2.023 1.439-3.502 3.157-3.502 1.698 0 3.029 1.48 3.029 3.502 0 2.001-1.331 3.458-3.029 3.458Zm2.857-7.939h-.086c-.558-.674-1.632-1.283-2.986-1.283-2.835 0-5.434 2.523-5.434 5.764 0 3.218 2.599 5.72 5.434 5.72 1.353 0 2.428-.609 2.986-1.305h.086v.827c0 2.197-1.16 3.37-3.029 3.37-1.525 0-2.47-1.108-2.857-2.044l-2.17.914c.623 1.523 2.278 3.393 5.027 3.393 2.922 0 5.392-1.74 5.392-5.981v-10.31h-2.363v.935Zm4.081 9.853h2.491V23.623h-2.491V40.5Zm6.165-5.568c-.064-2.218 1.697-3.35 2.964-3.35.989 0 1.827.5 2.105 1.22l-5.069 2.13Zm7.733-1.913c-.472-1.284-1.912-3.655-4.855-3.655-2.921 0-5.348 2.328-5.348 5.742 0 3.219 2.405 5.742 5.627 5.742 2.6 0 4.104-1.61 4.726-2.545l-1.933-1.305c-.644.958-1.526 1.588-2.793 1.588-1.267 0-2.169-.587-2.749-1.74l7.582-3.176-.257-.652Zm-60.411-1.893v2.436h5.757c-.172 1.37-.623 2.37-1.31 3.067-.838.848-2.148 1.783-4.447 1.783-3.544 0-6.315-2.892-6.315-6.48 0-3.59 2.77-6.482 6.315-6.482 1.912 0 3.308.762 4.34 1.74l1.696-1.718c-1.439-1.392-3.35-2.457-6.036-2.457-4.855 0-8.936 4.002-8.936 8.917s4.081 8.917 8.936 8.917c2.62 0 4.597-.87 6.144-2.502 1.59-1.609 2.084-3.87 2.084-5.697a7.95 7.95 0 0 0-.13-1.523h-8.098Zm14.772 7.46c-1.719 0-3.2-1.435-3.2-3.48 0-2.066 1.482-3.48 3.2-3.48 1.718 0 3.2 1.414 3.2 3.48 0 2.045-1.482 3.48-3.2 3.48Zm0-9.221c-3.137 0-5.693 2.414-5.693 5.741 0 3.307 2.556 5.742 5.693 5.742 3.136 0 5.692-2.435 5.692-5.742 0-3.327-2.556-5.741-5.692-5.741Zm12.418 9.222c-1.719 0-3.201-1.436-3.201-3.48 0-2.067 1.482-3.48 3.2-3.48 1.719 0 3.202 1.413 3.202 3.48 0 2.044-1.483 3.48-3.201 3.48Zm0-9.222c-3.136 0-5.692 2.414-5.692 5.741 0 3.307 2.555 5.742 5.692 5.742 3.135 0 5.692-2.435 5.692-5.742 0-3.327-2.557-5.741-5.692-5.741Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__b)",
    fillRule: "evenodd",
    d: "m14.013 43.726-.099-.096c-.382-.41-.61-1.041-.617-1.858V12.27c0-.905.267-1.587.714-1.995l16.52 16.726-16.518 16.724Zm-.716-1.993v.039-.039Zm0 .039v.158-.158Zm0-29.502v-.197.197Zm0-.197Zm0 0v-.007.007Zm0-.01v-.056l.001-.003v-.035l.001-.004v-.024l.001-.003v-.017l.001-.003V11.9l.001-.003v-.016l.002-.003v-.02l.001-.003v-.003.008l-.001.003v.014l-.001.003v.016l-.001.003v.018l-.001.003v.017l-.001.003v.025l-.001.004v.034l-.001.003v.058Zm.006-.23v-.001.002Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__c)",
    fillRule: "evenodd",
    d: "m36.036 32.776.126-.073 6.524-3.753c.622-.358 1.036-.792 1.244-1.251-.206.46-.621.893-1.244 1.252l-6.524 3.753-.126.072Zm.002-.198L30.532 27l5.507-5.576 6.649 3.824c.844.486 1.318 1.111 1.397 1.752v.002c-.079.637-.553 1.264-1.397 1.75l-6.648 3.824Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__d)",
    fillRule: "evenodd",
    d: "M15.19 44.363h-.042l-.02-.002h-.044l-.02-.002-.02-.001h-.002l-.02-.002-.02-.002H15l-.02-.002-.02-.002-.02-.003h-.001l-.02-.003-.02-.003h-.001l-.02-.003-.02-.003-.02-.003h-.001l-.019-.004h-.001l-.019-.004-.02-.005-.019-.004-.02-.005-.019-.005-.02-.005-.019-.005-.019-.006-.02-.006a2.023 2.023 0 0 1-.112-.038l-.09-.039a1.79 1.79 0 0 1-.105-.052l-.017-.01.016.01h.001l.104.052h.001l.09.038c.037.014.074.027.112.039l.02.006.018.006h.002l.018.005.02.005.019.004.02.005.019.005.02.004.019.005h.001l.019.003h.001l.02.003.02.004.02.003.02.003h.001l.02.003.02.002.02.002h.001l.02.003.02.001h.002l.02.002.02.002h.023l.02.002h.045l.02.001h.023-.001Zm.002 0h.047l.003-.002h.033l.004-.001h.016l.003-.001h.012-.031l-.004.002h-.032l-.004.001h-.048Zm0-.198c-.462 0-.865-.152-1.179-.439L30.531 27l5.508 5.577-19.354 11.134c-.535.307-1.043.453-1.494.453Zm-1.184-.245a1.603 1.603 0 0 1-.086-.085l.086.085Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__e)",
    fillRule: "evenodd",
    d: "M30.53 27.001 14.012 10.275a1.704 1.704 0 0 1 1.178-.438c.451 0 .96.146 1.496.454l19.352 11.134-5.507 5.576Zm5.632-5.702L16.685 10.094c-.537-.308-1.044-.455-1.496-.455h-.006.008c.45 0 .958.146 1.494.454l19.477 11.206Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.313 44.36c.42-.025.884-.17 1.372-.45l19.351-11.134L16.685 43.91c-.488.28-.953.426-1.372.45Zm-1.3-.437-.005-.003.005.003Zm-.09-.088-.01-.008.01.008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__f)",
    fillRule: "evenodd",
    d: "m36.036 32.775.126-.072-.126.072Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__g)",
    fillRule: "evenodd",
    d: "M13.914 43.827c-.388-.416-.617-1.061-.617-1.897 0 .835.228 1.48.617 1.896Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__h)",
    fillRule: "evenodd",
    d: "M13.914 43.826c-.388-.415-.617-1.06-.617-1.897v-.196c0 .835.228 1.481.617 1.897l.1.096-.1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__i)",
    fillRule: "evenodd",
    d: "m13.914 43.826.099-.1-.1.1Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__j)",
    fillRule: "evenodd",
    d: "m36.162 32.703-.124-.125 6.648-3.825c.844-.486 1.318-1.112 1.398-1.75 0 .234-.052.468-.154.697-.208.459-.622.893-1.244 1.25l-6.524 3.754Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M44.084 27.001c0-.707-.467-1.413-1.398-1.949L36.162 21.3l6.524 3.753c.932.536 1.399 1.243 1.398 1.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__k)",
    fillRule: "evenodd",
    d: "M44.084 27c-.08-.64-.553-1.266-1.398-1.75l-6.649-3.825.124-.126 6.525 3.753c.93.536 1.397 1.242 1.397 1.948Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#google-play-hebrew_svg__l)",
    fillRule: "evenodd",
    d: "M36.037 21.425 16.685 10.291c-.537-.308-1.044-.454-1.496-.454-.462 0-.864.152-1.178.438l-.097-.099c.03-.033.062-.065.095-.094l.003-.004c.312-.284.71-.436 1.166-.439h.01c.452 0 .96.147 1.497.455l19.477 11.205-.124.126Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.459 10.559v-1.15h2.514c1.228 0 2.108.267 2.637.798.529.532.794 1.41.794 2.635v3.71h.888V17.7h-7.148v-1.148h5.032v-3.723c0-.829-.165-1.415-.497-1.757-.33-.342-.904-.513-1.717-.513h-2.503Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M134.459 10.559h.133V9.545h2.381c1.212 0 2.053.264 2.543.758.492.492.755 1.332.755 2.54v3.844h.888v.879h-6.882v-.879h5.032v-3.858c-.001-.845-.165-1.467-.536-1.851l-.001-.002.001.002c-.371-.382-.982-.553-1.811-.554h-2.503v.135h.133-.133v.135h2.503c.796-.001 1.332.17 1.621.472v.001c.295.3.46.85.46 1.662v3.587h-5.032v1.42h7.415v-1.42h-.888v-3.574c-.001-1.242-.267-2.16-.835-2.73-.568-.57-1.484-.836-2.729-.837h-2.648v1.42h.133v-.136Zm12.858 0h-1.268v-1.15h4.424c1.228 0 2.11.265 2.643.795.533.53.801 1.409.801 2.638V17.7h-1.228v-4.87c0-.829-.165-1.415-.496-1.757-.332-.342-.909-.513-1.732-.513h-1.916v3.932c0 .828-.075 1.47-.224 1.925-.148.456-.388.783-.717.983-.329.2-.848.3-1.555.3h-.073v-1.148h.113c.312 0 .556-.057.735-.173.178-.114.304-.294.38-.537.076-.243.114-.61.114-1.102v-4.181l-.001.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M147.317 10.559v-.135h-1.134v-.88h4.29c1.212 0 2.055.264 2.549.757.497.49.762 1.33.761 2.541v4.724h-.961v-4.737c-.001-.845-.165-1.467-.535-1.851-.374-.382-.988-.553-1.826-.554h-2.05v4.067c0 .82-.076 1.45-.217 1.884-.142.432-.361.728-.659.91-.294.18-.792.282-1.487.28h-.073v.135h.133v-1.148h-.133v.134h.113c.328 0 .597-.06.806-.193.207-.134.352-.345.437-.61v-.003.002c.082-.267.118-.643.118-1.142v-4.316h-.133v.135h-.133v4.181c.001.484-.039.842-.107 1.062v-.001c-.071.222-.177.369-.325.464h.001c-.149.096-.368.152-.664.151h-.247v1.42h.207c.72-.002 1.257-.1 1.624-.32.36-.22.62-.58.775-1.058.156-.477.231-1.13.231-1.967v-3.797h1.782c.807-.001 1.347.17 1.636.473.294.3.459.85.459 1.662v5.006h1.494v-4.993c0-1.247-.268-2.166-.84-2.734-.573-.566-1.491-.832-2.736-.833h-4.558v1.42h1.402v-.136h-.133.133Zm7.379 6.047c1.228 0 2.193-.116 2.896-.345l-2.475-6.852h1.355l2.188 6.324c.624-.45 1.071-1.147 1.341-2.09.272-.945.408-2.355.408-4.234h1.287c0 2.086-.218 3.716-.657 4.892-.438 1.176-1.152 2.05-2.142 2.622-.989.572-2.389.906-4.201 1v-1.317Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.696 16.606v.135c1.237 0 2.213-.116 2.937-.352l.133-.043-2.458-6.801h1.07l2.215 6.404.144-.105c.654-.471 1.116-1.2 1.393-2.163.278-.967.412-2.385.413-4.271h-.133v.135h1.287V9.41h-.133c.001 2.075-.219 3.693-.649 4.844-.429 1.152-1.121 1.996-2.084 2.552-.961.557-2.342.89-4.141.983l.007.135h.133v-1.318h-.133v.135-.135h-.133v1.46l.141-.008c1.823-.096 3.241-.43 4.259-1.017 1.016-.587 1.754-1.491 2.201-2.692.447-1.2.665-2.844.665-4.94v-.134h-1.553v.135c0 1.871-.136 3.274-.403 4.195-.265.923-.696 1.59-1.291 2.019l.078.11.125-.045-2.22-6.414h-1.639l2.54 7.033.125-.047-.04-.128c-.682.222-1.635.339-2.855.338h-.134v.135h.134-.001Zm13.531-2.932c0 2.684-1.255 4.026-3.763 4.026h-2.13v-1.148h2.155c.851 0 1.478-.24 1.883-.716.404-.478.606-1.194.606-2.149v-.263c0-.96-.203-1.678-.61-2.153-.407-.475-1.033-.713-1.879-.713h-2.155V9.41h2.13c2.508 0 3.763 1.343 3.763 4.027v.237Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M168.227 13.674h-.134c0 1.322-.309 2.29-.904 2.927-.594.637-1.493.964-2.725.965h-1.996v-.879h2.021c.874.002 1.548-.248 1.984-.764.433-.512.639-1.263.639-2.235v-.264c0-.978-.206-1.73-.643-2.241-.439-.512-1.112-.76-1.98-.76h-2.021v-.878h1.996c1.232 0 2.129.328 2.725.964.595.637.904 1.605.904 2.928v.237h.267v-.237c0-1.362-.319-2.408-.977-3.113-.659-.706-1.643-1.05-2.919-1.049h-2.262v1.42h2.288c.823 0 1.403.227 1.779.665.377.44.577 1.122.577 2.065v.263c0 .937-.2 1.619-.575 2.06-.373.44-.953.668-1.781.669h-2.288v1.419h2.262c1.277 0 2.26-.344 2.919-1.049.658-.706.977-1.75.977-3.113h-.133Zm-40.648-.551h3.574v-.86h-3.574v.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M127.579 13.123h.132V12.4h3.309v.589h-3.441v.135h.132-.132v.135h3.708v-1.13h-3.842v1.13h.134v-.135Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__b",
    x1: 29.066,
    x2: 6.411,
    y1: 11.758,
    y2: 34.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__c",
    x1: 45.112,
    x2: 12.85,
    y1: 27.002,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__d",
    x1: 33.102,
    x2: 2.381,
    y1: 30.099,
    y2: 60.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__e",
    x1: 9.73,
    x2: 23.448,
    y1: 0.238,
    y2: 13.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__f",
    x1: 45.112,
    x2: 12.85,
    y1: 27.073,
    y2: 27.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCB300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#CC9700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#CC8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__g",
    x1: 33.102,
    x2: 2.381,
    y1: 30.1,
    y2: 60.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC2E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C0E4E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__h",
    x1: 29.066,
    x2: 6.411,
    y1: 11.758,
    y2: 34.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#008DE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    stopColor: "#00A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00B8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#00C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__i",
    x1: 33.102,
    x2: 2.38,
    y1: 30.1,
    y2: 60.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0333C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB0F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__j",
    x1: 45.112,
    x2: 12.85,
    y1: 27.002,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0C500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#E0A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E08900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__k",
    x1: 45.112,
    x2: 12.85,
    y1: 27.002,
    y2: 27.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#FFCE40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FFBC40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB540"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "google-play-hebrew_svg__l",
    x1: 9.73,
    x2: 23.448,
    y1: 0.238,
    y2: 13.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65B895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#62BD95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478,
    stopColor: "#50DB97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#44ED98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40F498"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "google-play-hebrew_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h180v54H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayHebrew);
export default __webpack_public_path__ + "static/media/google-play-hebrew.b2310d888e9e05fb0caf22e8e2764ac1.svg";
export { ForwardRef as ReactComponent };